import {AnalyticsEventHandler} from "../../../../infrastructure/handlers/analytics-event-handler";
import {AnalyticsService} from "../../../../third-party-services/analytics/analytics-service";
import {COMPETITOR_PLAYER_STATS} from "../../competitor-players-stats-module.consts";
import {CompetitorPlayerStatsModuleStatsDisplayEvent} from "../../models/analytics/competitor-player-stats-module.stats-display.event";
import {CompetitorPlayersStatsModuleState} from "../../models/competitor-players-stats-module.state";
import {CompetitorPlayersStatsModuleController} from "../../competitor-players-stats-module.controller";

export class CompetitorPlayerStatsModuleStatsDisplayEventHandler extends AnalyticsEventHandler {
  type = COMPETITOR_PLAYER_STATS.ACTION_TYPES.statsDisplayHandler;
  state: CompetitorPlayersStatsModuleState;
  controller: CompetitorPlayersStatsModuleController;

  static injectables = [AnalyticsService];

  constructor(analyticsService: AnalyticsService) {
    super(analyticsService);

    this.eventType = CompetitorPlayerStatsModuleStatsDisplayEvent;
  }
}
